import { render, staticRenderFns } from "./v-loader.vue?vue&type=template&id=3bf1cb84&"
import script from "./v-loader.vue?vue&type=script&lang=js&"
export * from "./v-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports